var render = function render(){
  var _vm$getSheetFlow, _vm$getCurrentSheetWi, _vm$getCurrentSheetWi2, _vm$getCurrentSheetWi3, _vm$getSheetFlow2, _vm$getCurrentSheetWi4;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-overlay', {
    staticClass: "w-100 bg-white",
    attrs: {
      "show": _vm.loading,
      "spinner-variant": "primary",
      "spinner-type": "grow"
    }
  }, [_c('sheet-header', {
    attrs: {
      "sheet": _vm.getCurrentSheetWithItems,
      "export-loading": _vm.exportLoading
    },
    on: {
      "download-pdf": _vm.downloadPdf,
      "download-word": _vm.downloadWord
    }
  }), _c('b-row', {
    staticClass: "mx-0 mt-3",
    attrs: {
      "align-v": "center"
    }
  }, [_c('form-checkbox', {
    staticClass: "mx-2",
    attrs: {
      "id": "time",
      "label": _vm.$t('event-flow.form.show-time')
    },
    model: {
      value: _vm.extraFunctionFormData.showTime,
      callback: function ($$v) {
        _vm.$set(_vm.extraFunctionFormData, "showTime", $$v);
      },
      expression: "extraFunctionFormData.showTime"
    }
  }), _c('form-checkbox', {
    staticClass: "mx-2",
    attrs: {
      "id": "brief",
      "label": _vm.$t('event-flow.form.show-brief')
    },
    model: {
      value: _vm.extraFunctionFormData.showBrief,
      callback: function ($$v) {
        _vm.$set(_vm.extraFunctionFormData, "showBrief", $$v);
      },
      expression: "extraFunctionFormData.showBrief"
    }
  }), _c('form-checkbox', {
    staticClass: "mx-2",
    attrs: {
      "id": "legend",
      "label": _vm.$t('event-flow.form.show-legend')
    },
    model: {
      value: _vm.extraFunctionFormData.showLegend,
      callback: function ($$v) {
        _vm.$set(_vm.extraFunctionFormData, "showLegend", $$v);
      },
      expression: "extraFunctionFormData.showLegend"
    }
  }), _c('form-checkbox', {
    staticClass: "mx-2",
    attrs: {
      "id": "timeline",
      "label": _vm.$t('event-flow.form.show-timeline')
    },
    model: {
      value: _vm.extraFunctionFormData.showTimeline,
      callback: function ($$v) {
        _vm.$set(_vm.extraFunctionFormData, "showTimeline", $$v);
      },
      expression: "extraFunctionFormData.showTimeline"
    }
  })], 1), _c('div', {
    staticClass: "event-flow my-3"
  }, [_c('div', {
    attrs: {
      "id": "pdf-canvas"
    }
  }, [_vm.getCurrentSheetWithItems ? _c('event-flow-location-header', {
    attrs: {
      "event-flow-locations": (_vm$getSheetFlow = _vm.getSheetFlow) === null || _vm$getSheetFlow === void 0 ? void 0 : _vm$getSheetFlow.eventFlowLocations,
      "extra-function-form-data": _vm.extraFunctionFormData
    }
  }) : _vm._e(), _c('div', {
    staticClass: "grid"
  }, [_vm.getCurrentSheetWithItems ? _c('event-flow-grid', {
    attrs: {
      "id": "grid",
      "step": _vm.getStep,
      "start-date-time": (_vm$getCurrentSheetWi = _vm.getCurrentSheetWithItems) === null || _vm$getCurrentSheetWi === void 0 ? void 0 : _vm$getCurrentSheetWi.startedAt,
      "end-date-time": (_vm$getCurrentSheetWi2 = _vm.getCurrentSheetWithItems) === null || _vm$getCurrentSheetWi2 === void 0 ? void 0 : _vm$getCurrentSheetWi2.endedAt,
      "event-flow-items": (_vm$getCurrentSheetWi3 = _vm.getCurrentSheetWithItems) === null || _vm$getCurrentSheetWi3 === void 0 ? void 0 : _vm$getCurrentSheetWi3.sheetItems,
      "event-flow-locations": (_vm$getSheetFlow2 = _vm.getSheetFlow) === null || _vm$getSheetFlow2 === void 0 ? void 0 : _vm$getSheetFlow2.eventFlowLocations,
      "extra-data": _vm.extraFunctionFormData,
      "responsibles": (_vm$getCurrentSheetWi4 = _vm.getCurrentSheetWithItems) === null || _vm$getCurrentSheetWi4 === void 0 ? void 0 : _vm$getCurrentSheetWi4.responsibles,
      "is-sheet": ""
    }
  }) : _vm._e()], 1)], 1)]), _c('div', {
    staticClass: "sheet-actions"
  }, [_vm.$store.getters['authenticationStorage/isAuthenticated'] ? _c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal.invite-modal",
      modifiers: {
        "invite-modal": true
      }
    }],
    on: {
      "click": _vm.openInvite
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.invite')) + " ")]) : _vm._e(), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.exportLoading
    },
    on: {
      "click": _vm.downloadPdf
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.pdf.download')) + " ")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.exportLoading
    },
    on: {
      "click": _vm.downloadWord
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('sheet.word.download')) + " ")])], 1), _c('custom-modal', {
    attrs: {
      "id": "invite-modal",
      "title": _vm.$t('sheet.invite')
    },
    on: {
      "on-hidden": _vm.resetInvite
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function () {
        return [_c('invite-form-sheet', {
          attrs: {
            "id": "invite",
            "error": _vm.getError,
            "loading": _vm.inviteLoading
          },
          on: {
            "submit": _vm.onSubmit,
            "cancel": _vm.close
          }
        })];
      },
      proxy: true
    }])
  }), _c('b-modal', {
    attrs: {
      "id": "export-loading-modal",
      "centered": "",
      "hide-footer": "",
      "hide-header": "",
      "no-close-on-backdrop": "",
      "no-close-on-esc": "",
      "size": "sm"
    }
  }, [_c('div', {
    staticClass: "export-loading-content"
  }, [_c('b-spinner', {
    attrs: {
      "variant": "primary",
      "type": "grow",
      "label": _vm.$t('sheet.export.loading.label')
    }
  }), _c('p', [_vm._v(_vm._s(_vm.exportLoadingMessage))])], 1)]), _vm.isChatbotAvailable && _vm.isChatbotOpen ? _c('ai-chatbot-window', {
    attrs: {
      "sheet-token": _vm.token,
      "messages": _vm.chatMessages
    },
    on: {
      "close": _vm.onCloseChatbot,
      "messages-change": _vm.onChatbotMessagesChange
    }
  }) : _vm.isChatbotAvailable ? _c('ai-chatbot-button', {
    on: {
      "click": _vm.onOpenChatbot
    }
  }) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }